module.exports = __webpack_public_path__ + "static/step5-3bfd882ae4c8cb298404e935ace45d7f.png";